export interface GuardedProductFieldRef {
  model: string;
  index: number;
  field: string;
}

export function guardedProductFieldDtl(
  model: string,
  index: number,
  field: "item_url" | "name",
): string {
  return `{% if tile_data.${model}|length > ${index} %}{{ tile_data.${model}[${index}].${field} }}{% endif %}`;
}

const GUARDED_FIELD_PATTERN =
  /^\{% if tile_data\.(\w+)\|length > (\d+) %\}\{\{ tile_data\.\1\[(\d+)\]\.([a-z]\w*) \}\}\{% endif %\}$/;

export function parseGuardedProductFieldDtl(
  text: string,
): GuardedProductFieldRef | null {
  const match = GUARDED_FIELD_PATTERN.exec(text.trim());
  if (!match) return null;
  const guardIndex = Number.parseInt(match[2], 10);
  const index = Number.parseInt(match[3], 10);
  if (guardIndex !== index) return null;
  return { model: match[1], index, field: match[4] };
}

const TILE_DATA_ITEM_REF_PATTERN = /tile_data\.(\w+)\[(\d+)\]/g;

export function collectTileDataItemRefs(
  text: string,
): Array<{ model: string; index: number }> {
  const refs: Array<{ model: string; index: number }> = [];
  for (const match of text.matchAll(TILE_DATA_ITEM_REF_PATTERN)) {
    if (match[1] === "dynamic") continue;
    refs.push({ model: match[1], index: Number.parseInt(match[2], 10) });
  }
  return refs;
}
